import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Typography,
  Box,
} from '@mui/material';

const PlanSelectionDialog = ({ open, onClose, availablePlans, onPlanUpgrade, loading, currentPlanName }) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth data-test-id="plan-selection-dialog">
        <DialogTitle>Select a Plan</DialogTitle>
        <DialogContent>
          <List>
            {availablePlans.map((plan) => (
              <ListItem key={plan.id} divider>
                <ListItemText
                  primary={plan.name.charAt(0).toUpperCase() + plan.name.slice(1)}
                  secondary={
                    <Box>
                      <Typography variant="body2">
                        {plan.description}
                      </Typography>
                      <Typography variant="body2">
                        {plan.monthly_limit ? Math.floor(plan.monthly_limit / 60) : '10'} hours per month
                      </Typography>
                    </Box>
                  }
                />
                <ListItemSecondaryAction>
                  <Box sx={{ textAlign: 'right' }}>
                    <Typography variant="h6" color="primary">
                      {plan.price_eur} EUR
                    </Typography>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => onPlanUpgrade(plan.id)}
                      disabled={loading || currentPlanName === plan.name}
                      data-test-id={`plan-select-btn-${plan.id}`}
                    >
                      {currentPlanName === plan.name ? 'Current Plan' : 'Select'}
                    </Button>
                  </Box>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} data-test-id="plan-selection-cancel">Cancel</Button>
        </DialogActions>
      </Dialog>
    );
}

export default PlanSelectionDialog;
